import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { RelativeDateFormat } from 'dibs-relative-date-format/exports/RelativeDateFormat';

// components
import { PriceAmount } from './PriceAmount';

// helpers
import { getAmountByCurrency } from './helpers';

export function PrivateOfferItemPrices({
    currency,
    amount,
    expiration,
    showExpirationDate,
    pricing,
    quantityDisplay,
    showRetail,
    showNet,
}) {
    const { netPrice, retailPrice } = pricing;
    const netAmount = showNet && getAmountByCurrency(netPrice, currency);
    const retailAmount = showRetail && getAmountByCurrency(retailPrice, currency);

    const formattedExpiration = showExpirationDate && <RelativeDateFormat value={expiration} />;
    const expirationNode = showExpirationDate && (
        <FormattedMessage
            id="price.privateOfferExpires"
            defaultMessage="Expires {expiration}"
            values={{ expiration: formattedExpiration }}
        />
    );

    return (
        <Fragment>
            {!!retailAmount && (
                <PriceAmount
                    showLabel
                    hasPrivateOffer
                    currency={currency}
                    amount={retailAmount}
                    quantityDisplay={quantityDisplay}
                />
            )}
            {!!netAmount && (
                <PriceAmount
                    type="NET"
                    showLabel
                    hasPrivateOffer
                    amount={netAmount}
                    currency={currency}
                    quantityDisplay={quantityDisplay}
                />
            )}
            <PriceAmount
                type="PRIVATE_OFFER"
                currency={currency}
                amount={amount}
                expiration={expirationNode}
                showLabel
                quantityDisplay={quantityDisplay}
            />
        </Fragment>
    );
}

PrivateOfferItemPrices.propTypes = {
    currency: PropTypes.string,
    amount: PropTypes.number,
    showListPriceLabel: PropTypes.bool,
    showExpirationDate: PropTypes.bool,
    showNet: PropTypes.bool,
    showRetail: PropTypes.bool,
    expiration: PropTypes.string,
    pricing: PropTypes.object,
    quantityDisplay: PropTypes.string,
};
